/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let amountText = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (total < minimum) {
        percentage = total / minimum;

        if (amountText) {
          let remaining = minimum - total;
          let format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amountText.innerHTML = formatMoney(remaining, format);
        }

        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'block';
          this.fullText.style.display = 'none';
        }
      } else {
        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'none';
          this.fullText.style.display = 'block';
        }
      }

      this.style.setProperty('--percentage', percentage);

      // logic for reserved message at bottom
      this.reservedContainer = document.querySelector('.cart-drawer--reserved-message');
      if (this.reservedContainer) {
        if (total >= minimum) {
          this.reservedContainer.style.display = 'block';
          this.startCountdown(this.reservedContainer.querySelector('.free-shipping--reserved-timer'));
        } else {
          this.reservedContainer.style.display = 'none';
          localStorage.removeItem('free_shipping_deadline');
        }
      }
    }

    startCountdown(timerElement) {
      if (!timerElement) return;

      const DURATION_MINUTES = 84;
      let deadline = localStorage.getItem('free_shipping_deadline');

      if (!deadline) {
        deadline = Date.now() + DURATION_MINUTES * 60 * 1000;
        localStorage.setItem('free_shipping_deadline', deadline);
      } else {
        deadline = parseInt(deadline, 10);
      }

      // A completed reservation must not leak into a later cart session.
      if (!Number.isFinite(deadline) || deadline <= Date.now()) {
        deadline = Date.now() + DURATION_MINUTES * 60 * 1000;
        localStorage.setItem('free_shipping_deadline', String(deadline));
      }

      const updateTimer = () => {
        const now = Date.now();
        const diff = deadline - now;

        if (diff <= 0) {
          timerElement.textContent = "00:00:00";
          localStorage.removeItem('free_shipping_deadline');
          if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
          }
          return;
        }

        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        timerElement.textContent =
          `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      };

      updateTimer();
      if (this.timerInterval) clearInterval(this.timerInterval);
      this.timerInterval = setInterval(updateTimer, 1000);
    }

    disconnectedCallback() {
      if (this.timerInterval) clearInterval(this.timerInterval);
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
